import { createContext, useContext } from "react";
import { StreamingState } from "../../types/streamingState";

type StreamingStateValue = {
  streamingState: StreamingState;
};

export const StreamingStateContext = createContext<
  StreamingStateValue | undefined
>(undefined);

export const useStreamingState = () => {
  const state = useContext(StreamingStateContext);

  if (state === undefined) {
    throw new Error(
      "useStreamingState must be used within a StreamingStateProvider provider."
    );
  }

  return state;
};
